import React from 'react';
import { NavHashLink } from 'react-router-hash-link';
import './PlanMensual.css';

const PlanMensual = () => {
  return (
    <section className='monthly-plan' aria-labelledby='monthly-plan-title'>
      <div className='monthly-plan-content'>
        <p className='monthly-plan-eyebrow'>Conocé nuestro</p>
        <h2 id='monthly-plan-title'>GOLDEN BEAUTY PASS</h2>
        <p className='monthly-plan-description'>Tu pase mensual de estética integral
        </p>
        <p className='monthly-plan-description'>Tratamientos pensados para acompañarte todos los meses
        </p>
        <NavHashLink target='_blank' to='https://goldenbeautypass.my.canva.site/' className='monthly-plan-button'>QUIERO CONOCER EL PASS</NavHashLink>
      </div>
    </section>
  );
};

export default PlanMensual;